import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './Views/Login';
import Home from './Views/Home';
import NavBar from './Components/NavBar';
import Dealers from './Views/Dealers';
import Distributor from './Views/Distributor';
import Lottery from './Views/Lottery';
import LotteryIn from './Views/LotteryIn';
import LotteryCategories from './Views/LotteryCategories';
import Footer from './Components/Footer';
import LotteryOut from './Views/LotteryOut';
import Reports from './Views/Reports';
import Stock from './Views/Stock';
import Stakeholders from './Views/Stakeholders';
import Settlements from './Views/Settlements';
import Returns from './Views/Returns';
import ReportMain from './Views/ReportMain';
import SalesReports from './Views/SalesReports';

function App() {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'; // Check login status

  return (
    <>
      <NavBar />
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/Home' element={isLoggedIn ? <Home /> : <Navigate to="/" />} />
        <Route path='/Dealers' element={isLoggedIn ? <Dealers /> : <Navigate to="/" />} />
        <Route path='/Distributor' element={isLoggedIn ? <Distributor /> : <Navigate to="/" />} />
        <Route path='/lottery' element={isLoggedIn ? <Lottery /> : <Navigate to="/" />} />
        <Route path='/lotteryIn' element={isLoggedIn ? <LotteryIn /> : <Navigate to="/" />} />
        <Route path='/LotteryOut' element={isLoggedIn ? <LotteryOut /> : <Navigate to="/" />} />
        <Route path='/LotteryCategories' element={isLoggedIn ? <LotteryCategories /> : <Navigate to="/" />} />
        <Route path='/lotteryStock' element={isLoggedIn ? <Stock /> : <Navigate to="/" />} />
        <Route path='/Reports' element={isLoggedIn ? <Reports /> : <Navigate to="/" />} />
        <Route path='/stakeholders' element={isLoggedIn ? <Stakeholders /> : <Navigate to="/" />} />
        <Route path='/settle' element={isLoggedIn ? <Settlements /> : <Navigate to="/" />} />
        <Route path='/return' element={isLoggedIn ? <Returns /> : <Navigate to="/" />} />
        <Route path='/ReportMain' element={isLoggedIn ? <ReportMain /> : <Navigate to="/" />} />
        <Route path='/salesReport' element={isLoggedIn ? <SalesReports /> : <Navigate to="/" />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
